/**
 * Custfy cart preview — ensure line item thumbs show customized design.
 * Liquid already prefers `_custom-preview`; this covers AJAX/stale DOM and
 * any surface that still rendered the catalogue image.
 */
(function () {
  "use strict";
  if (window.CustfyCartPreview) return;

  function previewFromProps(props) {
    if (!props || typeof props !== "object") return "";
    return (
      props["_custom-preview"] ||
      props["_custom-preview-0"] ||
      props["_custom-preview-pack-0"] ||
      props["Design preview"] ||
      props["Preview"] ||
      ""
    );
  }

  function applyFromCartJson(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    cart.items.forEach(function (item, index) {
      const preview = previewFromProps(item.properties);
      if (!preview) return;
      // Prefer matching by line key when available.
      let nodes = [];
      if (item.key) {
        const safeKey = String(item.key).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
        nodes = Array.from(
          document.querySelectorAll(
            '[data-cart-key="' +
              safeKey +
              '"] img, [data-cart-key="' +
              safeKey +
              '"] .cart-drawer-item__image, [data-cart-key="' +
              safeKey +
              '"] .cart-item__image, [data-cart-key="' +
              safeKey +
              '"] .cart-drawer-item__media img, [data-cart-key="' +
              safeKey +
              '"] .cart-item__media img',
          ),
        );
      }
      if (!nodes.length) {
        const articles = document.querySelectorAll(
          ".cart-drawer-item, .cart-item, [data-cart-line]",
        );
        const art = articles[index];
        if (art)
          nodes = Array.from(
            art.querySelectorAll(
              ".cart-drawer-item__media img, .cart-item__media img, .cart-item__image, img",
            ),
          );
      }
      nodes.forEach(function (img) {
        if (!img || img.dataset.custfyPreviewApplied === preview) return;
        img.src = preview;
        img.srcset = "";
        img.dataset.custfyPreview = "1";
        img.dataset.custfyPreviewApplied = preview;
      });
    });
  }

  // The boot script both dispatches custfy:cart:updated and calls apply()
  // directly in the same tick, so an add-to-cart used to fire two identical
  // /cart.js requests (185-310ms each). Share one in-flight request.
  let inFlight = null;

  function apply() {
    if (inFlight) return inFlight;
    const root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      "/";
    inFlight = fetch(root + "cart.js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (cart) applyFromCartJson(cart);
        return cart;
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        inFlight = null;
      });
    return inFlight;
  }

  document.addEventListener("custfy:cart:updated", function () {
    apply();
  });
  document.addEventListener("custogifts:cart:open", function () {
    apply();
  });

  // This asset is loaded site-wide from theme.liquid, so the load-time call was
  // spending a request on every collection and home page view — pages with no
  // cart markup to rewrite, while competing for the browser's connection budget
  // against the personalizer payload. Only run where there is something to fix.
  function hasCartMarkup() {
    return !!document.querySelector(
      "[data-cart-drawer], .cart-item, .cart-drawer-item, cart-drawer, cart-items",
    );
  }

  function applyIfCartOnPage() {
    if (hasCartMarkup()) apply();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyIfCartOnPage, {
      once: true,
    });
  } else {
    applyIfCartOnPage();
  }

  window.CustfyCartPreview = Object.freeze({ apply: apply });
})();
